// extracted by mini-css-extract-plugin
export default {"content":"PageShell_content__lu9Ms"};